@if (formCtrl().invalid && formCtrl().touched) {
  @if (formCtrl().errors; as error) {
    @if (error.isCustom) {
      <span class="fs__xs fw__500">
        {{ error.message }}
      </span>
    }
    @if (formCtrl().errors.required) {
      <span class="fs__xs fw__500">Required</span>
    }
    @if (formCtrl().errors.email) {
      <span class="fs__xs fw__500">Please type a valid email</span>
    }
    @if (formCtrl().errors.phone) {
      <span class="fs__xs fw__500">Please type a valid international phone number</span>
    }
    @if (formCtrl().errors.date) {
      <span class="fs__xs fw__500">Please type a valid date</span>
    }
    @if (formCtrl().errors.min) {
      <span class="fs__xs fw__500">The minimum required is {{ formCtrl().errors.min.min }}</span>
    }
    @if (formCtrl().errors.max) {
      <span class="fs__xs fw__500">The maximum allowed is {{ formCtrl().errors.max.max }}</span>
    }
    @if (formCtrl().errors.maxlength) {
      <span class="fs__xs fw__500"> The input must be shorter than {{ formCtrl().errors.maxlength.requiredLength }} characters </span>
    }
    @if (formCtrl().errors.pattern) {
      <span class="fs__xs fw__500">Invalid</span>
    }
    @if (formCtrl().errors.leadingZero) {
      <span class="fs__xs fw__500">Invalid number</span>
    }
    <!-- TODO: Handle the rest of the errors -->
  }
}
